/* AdVille — slider nativi della home (nessuna app, nessuna dipendenza) */
(function () {
  function step(track) {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function setup(wrap) {
    if (wrap.__avReady) return;
    wrap.__avReady = true;
    var track = wrap.querySelector('.av-slider');
    var prev = wrap.querySelector('.av-arrow--prev');
    var next = wrap.querySelector('.av-arrow--next');
    if (!track) return;

    function refresh() {
      var max = track.scrollWidth - track.clientWidth;
      var none = max < 4;
      [prev, next].forEach(function (b) { if (b) b.style.display = none ? 'none' : 'flex'; });
      if (none) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      clearTimeout(track.__t);
      track.__t = setTimeout(refresh, 90);
    });
    window.addEventListener('resize', function () {
      clearTimeout(track.__r);
      track.__r = setTimeout(refresh, 180);
    });
    refresh();
  }

  function playVideos() {
    document.querySelectorAll('.av-home video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('.av-slider-wrap').forEach(setup);
    playVideos();
    setTimeout(playVideos, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // il theme editor ricarica le sezioni senza ricaricare la pagina
  document.addEventListener('shopify:section:load', init);
})();
